<template lang="pug">
    Modal(v-model="isOpened" footer-hide width="800")
        p(slot="header") {{ $t("global.mission.title") }} {{ $store.state.platformPrefs.brandTitle }}
        p {{ $t("global.mission.description") }}
        br
        Steps(:current="currentStep" direction="vertical")
            template(v-for="task in tasks")
                Step(:title="task.title")
                    div(slot="content")
                        taskStep(
                            :isCompleted="task.isCompleted"
                            :isWithClaimBtn="task.isWithClaimBtn"
                            :isClaimed="task.isClaimed")
                            template(slot="taskContent")
                                TransformHtml(:template="task.taskDescription")
                            
</template>

<script>
import { getGroupAsset } from "@/api/groupasset.js";
import Vue from "vue";
import TransformHtml from "@/components/TransformHtml.vue";
import bus from "@/libs/bus.js";

Vue.component("taskStep", {
    props: {
        isCompleted: { type: Boolean, default: false },
        isWithClaimBtn: { type: Boolean, default: false },
        isClaimed: { type: Boolean, default: false }
    },
    methods: {
        // 未來做領取獎勵使用
        claim(x) {
            return;
            // console.log(x);
        }
    },
    template: `
        <div>
            <slot name="taskContent"></slot>
            <Button v-if="isWithClaimBtn" size="small" :disabled="!isCompleted" @click="claim('a')">領取</Button>
        </div>
    `
});

export default {
    components: { TransformHtml },
    data() {
        return {
            isOpened: false,
            tasks: [
                {
                    title: `${this.$i18n.t("global.mission.create")} ${this.$i18n.t("global.mission.PoPs.objectName")}`,
                    checkAssets: ["slbs", "edges"],
                    taskDescription: ` 
                        <div> 
                          <i18n tag="p" path="global.mission.PoPs.missionDescription">
                            <template #SlbsManage_router_link>
                              <router-link :to='{"name": "SlbsManage"}'>
                              SLB
                              </router-link>
                            </template>
                            <template #EdgesManage_router_link>
                              <router-link :to='{"name": "EdgesManage"}'>
                              EDGE
                              </router-link>
                            </template>
                          </i18n>
                        </div>
                    `,
                    isCompleted: false,
                    isWithClaimBtn: false,
                    isClaimed: false
                },
                {
                    title: `${this.$i18n.t("global.mission.create")} ${this.$i18n.t("global.mission.site.objectName")}`,
                    checkAssets: ["servicegroups"],
                    taskDescription: ` 
                        <div> 
                          <i18n tag="p" path="global.mission.site.missionDescription">
                            <template #ServiceGroup_router_link>
                              <router-link :to='{"name": "ServiceGroup"}'>
                                {{ $t("global.mission.site.objectName") }}
                              </router-link>
                            </template>
                          </i18n>
                        </div>
                     `,
                    isCompleted: false,
                    isWithClaimBtn: false,
                    isClaimed: false
                },
                {
                    title: `${this.$i18n.t("global.mission.create")} ${this.$i18n.t("global.mission.fqdn.objectName")}`,
                    checkAssets: ["fqdns"],
                    taskDescription: ` 
                        <div> 
                          <i18n tag="p" path="global.mission.fqdn.missionDescription">
                            <template #NoneProfileDomainSetting_router_link>
                              <router-link :to='{"name": "NoneProfileDomainSetting"}'>
                                {{ $t("global.mission.fqdn.objectName") }}
                              </router-link>
                            </template>
                          </i18n>
                        </div>
                     `,
                    isCompleted: false,
                    isWithClaimBtn: false,
                    isClaimed: false
                }
            ]
        };
    },
    methods: {
        async checkMissionCompleted() {
            // 對於每一個任務
            this.tasks.forEach(async task => {
                // 檢查他的物件筆數
                let checkAssetPromises = task.checkAssets.map(
                    async category => await getGroupAsset({ category, groupNames: this.$store.state.queryGroupName })
                );
                let getGroupAssetResults = await Promise.all(checkAssetPromises);

                // 皆大於0視為任務滿足
                task.isCompleted = getGroupAssetResults.every(e => e.data.data > 0);
            });
        }
    },
    async created() {
        await this.checkMissionCompleted();
    },
    mounted() {
        bus.$on("reloadTable", () => {
            this.checkMissionCompleted();
        });
    },
    beforeDestroy() {
        bus.$off("reloadTable");
    },
    computed: {
        currentStep() {
            var step = 0;
            /*
             * 任務進度(step), 為步驟中"最後一個完成"的任務序號
             * 比如完成了 0,1,2; 則進度為2; 如果完成了 0,1,2,4; 則進度還是為2
             * 引導使用者完成第三號任務; 使用者完成第三號任務後,
             * 完成列表為 0,1,2,3,4; 此時任務進度為4
             */

            for (let task of this.tasks) {
                if (task.isCompleted) step += 1;
                else break;
            }
            return step;
        }
    },
    watch: {
        "$store.state.queryGroupName": {
            deep: true,
            handler: async function(newVal) {
                await this.checkMissionCompleted();
            }
        },
        $route(to, from) {
            this.isOpened = false;
        },
        currentStep(val) {
            this.$emit("updateCurrentStep", val);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/GlobalMissionModal.vue